import { Dispatch } from "redux";
import { workBagService, WorkBagWorker } from "../../services/workBagService.ts";
import { setPeopleSearchWorkers } from "./actions.ts";
import { PeopleSearchProfile } from "../../types/peopleSearch.ts";

const buildWorkerDisplayName = (worker: WorkBagWorker) => {
  const full = `${worker.name ?? ""} ${worker.last_name ?? ""}`.trim();
  return full.length > 0 ? full : worker.email ?? "Trabajador";
};

const mapWorkerSkills = (worker: WorkBagWorker) => {
  const unique = new Map<number, string>();
  (worker.skill ?? []).forEach((item: any) => {
    const entity = item?.skill ?? item;
    if (!entity?.id) return;
    const id = Number(entity.id);
    if (Number.isNaN(id)) return;
    if (!unique.has(id)) {
      unique.set(id, String(entity.name ?? ""));
    }
  });
  return Array.from(unique.entries()).map(([id, name]) => ({ id, name }));
};

const mapWorkerJurisdictions = (worker: WorkBagWorker) => {
  const unique = new Map<number, string>();
  (worker.jobBoardZones ?? []).forEach((zone: any) => {
    const entity = zone?.jurisdiccion ?? {};
    const id = Number(entity?.id ?? zone?.id);
    if (Number.isNaN(id)) return;
    const name = String(entity?.name ?? zone?.city ?? "");
    if (!unique.has(id)) {
      unique.set(id, name);
    }
  });
  return Array.from(unique.entries()).map(([id, name]) => ({ id, name }));
};

const mapWorkerToProfile = (worker: WorkBagWorker): PeopleSearchProfile => {
  const displayName = buildWorkerDisplayName(worker);
  const skills = mapWorkerSkills(worker);
  const jurisdictions = mapWorkerJurisdictions(worker);

  return {
    id: String(worker.id),
    type: "WORKER",
    displayName,
    avatarUrl: null,
    skills,
    jurisdictions,
    contact: {
      phone: worker.phone ?? null,
      email: worker.email ?? null,
      website: null,
    },
    tags: [],
    rating: null,
    portfolioCount: undefined,
    availability: worker.employment_end_date
      ? new Date(worker.employment_end_date) <= new Date()
        ? "Disponibilidad inmediata"
        : `Disponible desde ${new Date(worker.employment_end_date).toLocaleDateString("es-AR")}`
      : null,
    unemploymentFund: Boolean(worker.unemployment_fund),
    hasIdentityValidated: Boolean(worker.identity_validated ?? false),
    rawType: "WORKER",
    source: "WORKER",
    raw: worker,
  };
};

const mapWorkers = (workers: WorkBagWorker[]) => workers.map(mapWorkerToProfile);

export const fetchWorkersByFilters = (params: {
  jurisdictions?: number[];
  cities?: string[];
  skills?: number[];
  identityValidated?: boolean;
}) => async (dispatch: Dispatch) => {
  try {
    const workers = await workBagService.filterWorkersByParams(params);
    const normalized = mapWorkers(workers);
    dispatch(setPeopleSearchWorkers(normalized));
  } catch (error) {
    console.error("fetchWorkersByFilters", error);
    dispatch(setPeopleSearchWorkers([]));
  }
};

export const fetchAllWorkers = () => async (dispatch: Dispatch) => {
  try {
    const workers = await workBagService.fetchWorkers();
    const normalized = mapWorkers(workers);
    dispatch(setPeopleSearchWorkers(normalized));
  } catch (error) {
    console.error("fetchAllWorkers", error);
    dispatch(setPeopleSearchWorkers([]));
  }
};

